export class SettingsItem {
  public constructor (
    readonly key: string,
    readonly value: boolean | number | string,
    readonly type: string
  ) {}
}
